import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["contentType", "published", "purchased", "sent"]

  connect() {
    // Auto-submit form when any input changes
    this.autoSubmitFunc = this.autoSubmit.bind(this)
    this.debounceAutoSubmitFunc = this.debounceAutoSubmit.bind(this)

    this.element.addEventListener("change", this.autoSubmitFunc)
    this.element.addEventListener("input", this.debounceAutoSubmitFunc)
  }

  disconnect() {
    this.element.removeEventListener("change", this.autoSubmitFunc)
    this.element.removeEventListener("input", this.debounceAutoSubmitFunc)

    // Clear any pending timeouts
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout)
    }
  }

  selectType({ params }) {
    this.contentTypeTarget.value = params.contentType
  }

  selectPublished({ params }) {
    this.publishedTarget.value = params.published
  }

  selectPurchased({ params }) {
    this.purchasedTarget.value = params.purchased
  }

  selectSent({ params }) {
    this.sentTarget.value = params.sent
  }

  autoSubmit(event) {
    // Skip if the target is not a form input
    if (!this.isFormInput(event.target)) return

    this.submitForm()
  }

  debounceAutoSubmit(event) {
    // Clear existing timeout
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout)
    }

    // Set a new timeout to submit after 300ms of inactivity
    this.debounceTimeout = setTimeout(() => {
      this.submitForm()
    }, 300)
  }

  submitForm() {
    // Find the form element (could be the controller element itself or a child)
    const form = this.element.tagName === "FORM" ? this.element : this.element.querySelector("form")

    if (form) {
      // Use Rails UJS or Turbo to submit the form
      if (form.dataset.turbo !== "false") {
        // Turbo form submission
        form.requestSubmit()
      } else {
        // Standard form submission
        form.submit()
      }
    }
  }

  isFormInput(element) {
    const inputTypes = ["INPUT", "SELECT", "TEXTAREA"]
    return inputTypes.includes(element.tagName) &&
      element.type !== "submit" &&
      element.type !== "button" &&
      element.type !== "reset"
  }
}
